import { render, staticRenderFns } from "./SettingEdit.vue?vue&type=template&id=360ec786&scoped=true"
import script from "./SettingEdit.vue?vue&type=script&lang=js"
export * from "./SettingEdit.vue?vue&type=script&lang=js"
import style0 from "./SettingEdit.vue?vue&type=style&index=0&id=360ec786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360ec786",
  null
  
)

export default component.exports